export default __webpack_public_path__ + "../img/48c8d9277976f5a4c8ee83b1f3b013fd.png";